import { loadD1C } from "./js/D1C/d1c";
import { watchCookie } from "./utils/watchCookie";

// Funcion para medir la velocidad del internet
const velocityInternet = async  ()=>{
  // @ts-ignore
  return new Promise((resolve, reject) => {
    var conexion = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conexion && conexion.downlink) {
      var velocidad = conexion.downlink;
      // Aquí puedes definir la velocidad para considerar una conexión a 3G o menor
      resolve(velocidad);
    }
  })
 

}

/*Codigo de linea 6 a 99 lo recuperamos de : repsol/main/satellite.js*/

if (typeof DFI_client !== "object") {
  var DFI_client = {};
}


/*-----Carga D1C y Whatsapp D3A----*/
/*Cargamos D1C*/



if(document.getElementById("initWalmeric")===null){
  loadD1C();
}

// Carga: -consent analytics en dataLayerMovistarProsegur / -cookies(_ga y _ga_L6WVX7EBK4) en la pasarela de google
const conexion = await velocityInternet();
conexion <= 2 ? setTimeout(()=>{watchCookie()},1500) : watchCookie();




/*DCL gracias*/
globalThis.DCL_gracias = (resp) => {
  console.log("Lead Exitoso");
  console.log(resp);
  globalThis.DCL.set.forms();
};

globalThis.DFI_client=DFI_client